module.exports = __webpack_public_path__ + "img/TK.68b16936.jpg";